<template>
<!--  header-->
  <HeaderCom ></HeaderCom>
  <div ref="headerBox">

  </div>
  <div class="w-100"  :style="{'min-height':minHeight}">
<!--    <router-view></router-view>-->
<!--    <router-view v-slot="{ Component, route }">-->
<!--      <transition :name="route.meta.transition || 'fade'">-->
<!--        <component :is="Component" />-->
<!--      </transition>-->
<!--    </router-view>-->
    <router-view v-slot="{ Component }">
      <transition>
<!--        <keep-alive>-->
<!--          <component :is="Component" />-->
<!--        </keep-alive>-->
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
  <div ref="footerBox">
    <FooterCom></FooterCom>
  </div>




</template>
<script setup>
// @ is an alias to /src

import HeaderCom from '@/layout/HeaderCom.vue'
import {onMounted, onUnmounted,ref} from "vue";
const headerBox = ref()
const footerBox = ref()
const minHeight = ref(`100px`)
onMounted(()=>{
  // const
  getScreenHeight()
  window.addEventListener('resize', getScreenHeight, false)
})

onUnmounted(()=>{
  window.removeEventListener('resize', getScreenHeight)
})

// 获取屏幕高度
const getScreenHeight = ()=>{
  const screenH = document.body.clientHeight // 屏幕高度
 const screenAh =  window.screen.availHeight // 屏幕可见区域高度
  let headerH = 0,footerH = 0
  if(headerBox.value && headerBox.value.offsetHeight){
    headerH = headerBox.value.offsetHeight
  }
  if(footerBox.value && footerBox.value.offsetHeight){
    footerH = footerBox.value.offsetHeight
  }
  minHeight.value = (screenH - headerH - footerH) + "px"
}


</script>
<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100vw;
  font-weight: 800;
  //min-height: 100vh;
  //overflow-x: hidden;
  //color: #2c3e50;
}


</style>
